export default {
	//cod_tarefa : "",
	//	cod_user : "",
	settings: {
		title: 'Titulo do formulário',

		cancelButton: false,
		saveButton: true,
		mailButton: false,
		printButton: false,

		required: false,
		width: 'modal-md',

		type: '',

		emailInfos: {
			template: '',
			cc: '',
			titulo: '',
			body: '',
			de: '',
			paraOpt: 'etatico',
			emailEstatico: '',
		},

		saveInfo: {
			type: 'virtualTable',
			dataBase: '',
		},

		CancelInfo: 'cancel',
		printInfo: '',
	},
	inputs: [],
	abas: {
		type: 'nav-tabs',
		active: '',
		list: [],
	},
	//data : [],
	//titulo : "",
	//type: ""
};



// WEBPACK FOOTER //
// ./src/components/models/create-form/resets/modal-form-load.js